import { AFDataObject, AFMessageType } from ".";

export enum TokenSource {
  'PUMPFUN' = 'PUMPFUN',
  'LAUNCHLAB' = 'LAUNCHLAB',
  'OTHERS' = 'OTHER'
}

export interface TokenInfoRawData {
  tokenAddress: string;
  tokenSymbol: string;
  tokenName: string;
  timestamp: Date;
  imageUrl: string;
  tokenSource: TokenSource;
  website?: string;
  twitter?: string;
  telegram?: string;
  firstTransferAt?: Date;
  poolAddress?: string;
}

export interface TokenInfoStateData extends TokenInfoRawData {
    lastUpdated: Date;
}

export class TokenInfo implements AFDataObject<TokenInfoRawData, TokenInfoStateData> {
  public tokenAddress: string;
  public tokenSymbol: string;
  public tokenName: string;
  public timestamp: Date;
  public imageUrl: string;
  public tokenSource: TokenSource;
  public website?: string;
  public twitter?: string;
  public telegram?: string;
  public firstTransferAt?: Date;
  public poolAddress?: string;
  public lastUpdated: Date;

  constructor(data: TokenInfoRawData | null, lastUpdated?: Date) {
    // 기본값 설정
    this.tokenAddress = data?.tokenAddress || '';
    this.tokenSymbol = data?.tokenSymbol || 'Unknown';
    this.tokenName = data?.tokenName || 'Unknown';
    this.timestamp = data?.timestamp ? new Date(data.timestamp) : new Date(0);
    this.imageUrl = data?.imageUrl || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYoWXFc1ZD2ULUuOL8Xtb8V8rizl57AIB3rw&s';
    this.tokenSource = data?.tokenSource || TokenSource.OTHERS;
    this.website = data?.website || '';
    this.twitter = data?.twitter || '';
    this.telegram = data?.telegram || '';
    this.poolAddress = data?.poolAddress || '';
    this.firstTransferAt = data?.firstTransferAt ? new Date(data.firstTransferAt) : new Date(0);
    this.lastUpdated = new Date(lastUpdated || 0);
  }

  static create(data: TokenInfoRawData | null, lastUpdated?: Date): TokenInfo {
    return new TokenInfo(data, lastUpdated);
  }

  getMessageType(): AFMessageType {
    return AFMessageType.TOKEN_INFO;
  }

  toRawData(): TokenInfoRawData {
    return {
      tokenAddress: this.tokenAddress,
      tokenSymbol: this.tokenSymbol,
      tokenName: this.tokenName,
      timestamp: this.timestamp,
      imageUrl: this.imageUrl,
      tokenSource: this.tokenSource,
      website: this.website,
      twitter: this.twitter,
      telegram: this.telegram,
      firstTransferAt: this.firstTransferAt,
      poolAddress: this.poolAddress
    };
  }

  toStateData(): TokenInfoStateData {
    return {
      ...this.toRawData(),
      lastUpdated: this.lastUpdated
    };
  }

  filter(existingData: TokenInfoStateData): boolean {
   return Number(this.lastUpdated) > Number(existingData.lastUpdated);
  }
}
